// GT TECHNICAL INFORMATION PAGE - UPDATED JS
document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll('.gt-tech-accordion-item');

  accordionItems.forEach(function (item) {
    const button = item.querySelector('.gt-tech-accordion-btn');

    if (!button) return;

    button.addEventListener('click', function () {
      const isActive = item.classList.contains('active');

      accordionItems.forEach(function (otherItem) {
        otherItem.classList.remove('active');
      });

      if (!isActive) {
        item.classList.add('active');
      }
    });
  });

  const tabButtons = document.querySelectorAll('.gt-tech-tab');

  tabButtons.forEach(function (tab) {
    tab.addEventListener('click', function (event) {
      event.stopPropagation();

      const target = tab.getAttribute('data-tab');
      const panel = tab.closest('.gt-tech-panel');

      if (!panel || !target) return;

      panel.querySelectorAll('.gt-tech-tab').forEach(function (btn) {
        btn.classList.remove('active');
      });

      panel.querySelectorAll('.gt-tech-tab-content').forEach(function (content) {
        content.classList.remove('active');
      });

      tab.classList.add('active');

      const activeContent = panel.querySelector('[data-content="' + target + '"]');
      if (activeContent) activeContent.classList.add('active');
    });
  });
});